import React, { useState, useEffect } from "react";
import { Card } from "antd";
// import { ANNOUNCEMENTS } from "./announcements";
import AnnouncementCard from "../components/AnnouncementCard";
import AnnouncementWidget from "../components/AnnouncementWidget";
import { useDispatch, useSelector } from "react-redux";
import { 
  doAnnouncementDelete,
  doAnnouncementReset, 
  getAnnouncementList 
} from "../../../../redux/announcement/announcementState";
import dayjs from "dayjs";
import { displayIcon } from "variables/icons";

const ImportantAnnouncementBoard = ({userType}) => {


  const dispatch = useDispatch();
  const recordList = useSelector((state) => state.announcement.announcementList?.items);
  const pagination = useSelector((state) => state.announcement.announcementList?.pagination);
  const filters = useSelector((state) => state.announcement.announcementList?.filters);

  const ITEMS_PER_PAGE = 4;

  const [selectedId, setSelectedId] = useState(0);
  const [announcementPage, setAnnouncementPage] = useState(0);

  const activeAnnouncements = recordList.filter((announcement) => {
    const today = dayjs().startOf("day");

    const from = announcement.ann_period_from
      ? dayjs(announcement.ann_period_from).startOf("day")
      : null;

    const until = announcement.ann_period_to
      ? dayjs(announcement.ann_period_to).startOf("day")
      : null;

    return (
      (!from || today.isSame(from) || today.isAfter(from)) &&
      (!until || today.isSame(until) || today.isBefore(until))
    );
  });

  const totalPages = Math.ceil(activeAnnouncements.length / ITEMS_PER_PAGE);

  const startIndex = announcementPage * ITEMS_PER_PAGE;

  const visibleAnnouncements = activeAnnouncements.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );

  const selectedAnnouncement = activeAnnouncements[selectedId];

  useEffect(() => {
    dispatch(getAnnouncementList({paginate: pagination.per_page}));
  }, [dispatch, pagination.per_page]);

  // const handleRemove = (id) => {
  //   setList(prev => prev.filter((_, index) => index !== id));

  //   setSelectedId(prev => {
  //     if (prev === id) return 0;
  //     if (prev > id) return prev - 1;
  //     return prev;
  //   });
  // };

  // if (list.length === 0) return null;

  const handleViewDetails = (index) => {
    setSelectedId(index);
    setAnnouncementPage(Math.floor(index / ITEMS_PER_PAGE));
  }

  return (
    <Card
      className="flex flex-col gap-6 rounded-xl bg-gradient-to-br from-violet-50 via-white to-purple-50 overflow-hidden dark:from-violet-900 dark:via-intsamis-900 dark:to-purple-900"
    >
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-violet-500/10 to-purple-500/10 rounded-full blur-3xl -z-0"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-blue-500/10 to-cyan-500/10 rounded-full blur-3xl -z-0"></div>

      <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 relative z-10">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-3 rounded-xl bg-gradient-to-br from-violet-500 to-purple-600 shadow-lg shadow-violet-500/30">
              {displayIcon("Megaphone", "w-6 h-6 text-white")}
            </div>
            <div>
              <h4 className="text-[20px] text-violet-600 dark:text-violet-100">
                Important Announcements
              </h4>
              <p className="muted-text">
                Stay informed with the latest updates
              </p>
            </div>
          </div>

          <div className="status-indicator text-xs bg-gradient-to-r from-violet-600 to-purple-600 text-white border-0 shadow-lg">
             {activeAnnouncements.length} Active
          </div>
        </div>
      </div>

      <div className="p-6 relative z-10 space-y-4">
        {selectedAnnouncement && (
          <AnnouncementCard
            key={selectedAnnouncement.ann_id}
            announcement={selectedAnnouncement}
            isSelected={true}
            selectedId={selectedId}
          />
        )}
        {activeAnnouncements.length > 0 ? (
          <div className="flex items-center justify-between mb-2">
            <h4 className="text-xs font-semibold muted-text">
              All Announcements
            </h4>

            <div className="flex items-center gap-1">
              {activeAnnouncements.map((announcement, index) => (
                <button
                  key={announcement.ann_id}
                  onClick={() => {
                    handleViewDetails(index);
                  }}
                  className={`rounded-full transition-all duration-300 ${
                    index === selectedId
                      ? "w-4 h-1.5 bg-violet-600"
                      : "w-1.5 h-1.5 bg-slate-300 hover:bg-slate-400"
                  }`}
                />
              )
              )}
            </div>
          </div>
        ) : (
          <span className="flex justify-center text-base muted-text">No announcements</span>
        )}
        <AnnouncementWidget
          announcements={visibleAnnouncements}
          selectedId={selectedId}
          setSelectedId={setSelectedId}
          announcementPage={announcementPage}
          totalPages={totalPages}
          setAnnouncementPage={setAnnouncementPage}
          totalAnnouncementCount={activeAnnouncements.length}
          userType={userType}
          // onRemove={handleRemove}
        />
      </div>
    </Card>
  );
};

export default ImportantAnnouncementBoard;
